import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import qs from 'qs';
import AutocompleteFilter from './Filters/AutocompleteFilter';
import CheckboxFilter from './Filters/CheckboxFilter';
import DateRangeFilter from './Filters/DateRangeFilter';
import DropdownFilter from './Filters/DropdownFilter';
import RadioFilter from './Filters/RadioFilter';
import TagFilter from './Filters/TagFilter';
import TextFilter from './Filters/TextFilter';
import RegionFilter from './Filters/RegionFilter';

export default class Filters extends Component {
  static propTypes = {
    collections: PropTypes.object,
  };

  static defaultProps = {
    collections: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      collapsed: this.localStorageValue() || false,
      sorter:
        Object.values(props.collections).filter((s) => s.id === 'sort').length > 0
          ? Object.values(props.collections).find((s) => s.id === 'sort')
          : null,
      filters: Object.values(props.collections).reduce((acc, item) => {
        if (item.id !== 'sort') {
          acc[item.id] = { ...item, expanded: true };
        }
        return acc;
      }, {}),
    };
  }

  componentDidMount() {
    this.updateBodyClasses(this.state.collapsed);
  }

  localStorageValue() {
    return localStorage.getItem('filtersCollapsed') !== null
      ? localStorage.getItem('filtersCollapsed') === 'true'
      : null;
  }

  updateBodyClasses(collapsed) {
    if (collapsed) {
      document.body.classList.remove('f-filters-expanded-fixed');
      document.body.classList.add('f-filters-collapsed-fixed');
    } else {
      document.body.classList.add('f-filters-expanded-fixed');
      document.body.classList.remove('f-filters-collapsed-fixed');
    }
  }

  handleCollapseTriggerClick = () => {
    const { collapsed } = this.state;
    this.updateBodyClasses(!collapsed);
    this.setState({ collapsed: !collapsed });
    localStorage.setItem('filtersCollapsed', !collapsed);
  };

  handleUpdateDataReactProps(attr, filter) {
    const htmlElement = document.querySelector('[data-react-class="Filters"]');
    const props = JSON.parse(htmlElement.getAttribute('data-react-props'));
    props.collections[filter.id][attr] = filter[attr];
    htmlElement.setAttribute('data-react-props', JSON.stringify(props));
  }

  handleFilterChange(attr, filter) {
    const stateUpdates = {};

    stateUpdates[filter.id] = { [attr]: { $set: filter[attr] } };

    const newState = update(this.state, { filters: stateUpdates });

    this.handleUpdateDataReactProps(attr, filter);
    this.setState(newState);
  }

  handleSorterChange(attr, sorter) {
    const stateUpdates = { [attr]: { $set: sorter[attr] } };

    const newState = update(this.state, { sorter: stateUpdates });

    this.handleUpdateDataReactProps(attr, sorter);
    this.setState(newState);
  }

  handleResetAllFiltersClick = () => {
    Object.values(this.state.filters).forEach((filter) => {
      setTimeout(() => {
        $(document).trigger(`${filter.id}-reset`);
      }, 100);
    });

    const params = qs.parse(window.location.search.slice(1));

    Object.keys(params).forEach((key) => {
      if (
        key !== 'sort' &&
        !(window.location.pathname.includes('search') && (key === 'query' || key === 'vertical')) &&
        !(window.location.pathname.includes('programming') && key === 'date')
      ) {
        delete params[key];
      }
    });

    router.push({
      pathname: location.pathname,
      search: qs.stringify(params, { arrayFormat: 'brackets' }),
      state: { revisitWithSearch: true },
    });
  };

  handleResetSorterClick = () => {
    $(document).trigger('sorter-reset');

    const params = qs.parse(window.location.search.slice(1));

    delete params.sort;

    router.push({
      pathname: location.pathname,
      search: qs.stringify(params, { arrayFormat: 'brackets' }),
      state: { revisitWithSearch: true },
    });
  };

  hasSelectedFilters() {
    // Filters have selected filters if:
    // Is TagFilter (has ontology property) and any of the ontology attributes have the selected array not empty
    // Is a type of filter which can have multiple selected values (array) and:
    //   - filter has defaultValue (array) and the selected values are different from the default values
    //   - filter doesn't have defaultValue but the selected array is not empty
    // Is a type of filter which can only have a selected value and is not null neither equal to the defaultValue

    const filtersWithSelectedValues = Object.values(this.state.filters).filter((filter) => {
      if (filter.ontology !== undefined) {
        return (
          Object.values(filter.ontology).filter((ontologyType) => ontologyType.selected.length > 0)
            .length > 0
        );
      }
      if (Array.isArray(filter.selected)) {
        if (Array.isArray(filter.defaultValue) && filter.defaultValue.length > 0) {
          return !filter.selected.reduce(
            (acc, item) =>
              acc &&
              filter.selected.length === filter.defaultValue.length &&
              filter.defaultValue.indexOf(item) !== -1,
            true
          );
        }
        return filter.selected.length > 0;
      }
      return filter.selected !== null && filter.selected !== filter.defaultValue;
    });

    return filtersWithSelectedValues.length > 0;
  }

  hasSelectedSorter() {
    return (
      this.state.sorter.selected !== null &&
      this.state.sorter.selected !== this.state.sorter.defaultValue
    );
  }

  renderFilter(filter) {
    const filters = {
      RegionFilter,
      AutocompleteFilter,
      CheckboxFilter,
      DateRangeFilter,
      DropdownFilter,
      RadioFilter,
      TagFilter,
      TextFilter,
    };

    const FilterComponent = filters[`${filter.type}Filter`];

    return React.createElement(FilterComponent, {
      ...filter,
      onChange: this.handleFilterChange.bind(this),
    });
  }

  renderFilters() {
    const filters = Object.values(this.state.filters).map((filter, index) => (
      <div
        className={index < Object.values(this.state.filters).length - 1 ? 'u-border-b' : 0}
        key={index}>
        {this.renderFilter(filter)}
      </div>
    ));

    const tailwindConfig = require('../../../../tailwind.config');
    const isMobile = window.innerWidth < Number(tailwindConfig.theme.screens.lg.split('px')[0]);

    return (
      <div className="u-relative">
        <div
          className={`filters-header ${this.state.sorter !== null ? 'u-border-t' : ''} ${
            isMobile ? 'u-p-6' : ''
          }`}>
          <span className="lg:u-text-sm u-font-semibold">Filters</span>
          <div className="u-flex u-items-center">
            {this.hasSelectedFilters() && (
              <span
                id="filters-reset-all"
                className="u-text-xs u-text-old-primary-color-blue hover:u-underline u-cursor-pointer"
                onClick={this.handleResetAllFiltersClick}>
                Reset all
              </span>
            )}
          </div>
        </div>
        <ul className="u-m-0">{filters}</ul>
      </div>
    );
  }

  renderSorter() {
    const sorterElement = React.createElement(DropdownFilter, {
      ...this.state.sorter,
      onChange: this.handleSorterChange.bind(this),
      collapse: false,
    });

    const tailwindConfig = require('../../../../tailwind.config');
    const isMobile = window.innerWidth < Number(tailwindConfig.theme.screens.lg.split('px')[0]);

    return (
      <div className="u-relative">
        <div className={`filters-header ${isMobile ? 'u-p-6' : ''}`}>
          <span className="lg:u-text-sm u-font-semibold">Sort by</span>
          <div className="u-flex u-items-center">
            {this.hasSelectedSorter() && (
              <span
                id="sorter-reset-all"
                className="u-text-xs u-text-old-primary-color-blue hover:u-underline u-cursor-pointer"
                onClick={this.handleResetSorterClick}>
                Reset
              </span>
            )}
          </div>
        </div>
        <ul className="u-m-0 u-pt-4">{sorterElement}</ul>
      </div>
    );
  }

  render() {
    return (
      <div
        className={`filters ${this.state.collapsed ? 'filters--collapsed' : 'filters--expanded'}`}>
        <div className="filters-content">
          {this.state.sorter !== null && this.renderSorter()}
          {Object.values(this.state.filters).length > 0 && this.renderFilters()}
        </div>
        <div className="u-hidden lg:u-block">
          <span className="filters-collapse-trigger" onClick={this.handleCollapseTriggerClick}>
            <i
              className={`Icon u-m-0 u-text-white ${
                this.state.collapsed ? 'Icon-chevron-left' : 'Icon-chevron-right'
              }`}
            />
          </span>
        </div>
        <div className="lg:u-hidden u-border-t">
          <span className="Button Button--primary u-mx-6 u-my-4 u-flex u-justify-center Modal-dismiss u-py-2 u-text-base">
            {this.hasSelectedFilters() || (this.state.sorter !== null && this.hasSelectedSorter())
              ? 'Apply Filters'
              : 'Close'}
          </span>
        </div>
      </div>
    );
  }
}
